<template>
  <div class="map-view" :class="{ 'map-detail': isShowMapDetail }">
    <div id="container" class="map-container"></div>
    <div v-if="isShowMapDetail" class="active-cinema">
      456
    </div>
  </div>
</template>

<script>
import * as R from 'ramda'
export default {
  props: {
    cinemas: Array,
    isGeolocation: Boolean
  },
  data() {
    return {
      isShowMapDetail: false,
      map: {},
      marker: {},
      iconMovies: require('../../image/cinema/iconMovies@2x.png'),
      activeItem: {}
    }
  },
  mounted() {
    this.map = new AMap.Map('container')
    this.map.on('click', e => {
      this.isShowMapDetail = true
      // let target = e.target
      // const lng = e.lnglat.lng
      // const lat = e.lnglat.lat
      this.activeItem = this.cinemas[0]
    })
  },
  watch: {
    marker(n, o) {
      // console.log(n,o)
      this.map.remove(o)
      this.map.add(n)
      this.map.setFitView()
    },
    cinemas(n, o) {
      if (!R.equals(n, o)) {
        this.marker = R.map(n => {
          if (n.longitude && n.latitude) {
            return new AMap.Marker({
              position: [n.longitude, n.latitude],
              icon: new AMap.Icon({
                imageSize: new AMap.Size(21, 21),
                image: this.iconMovies
              }),
              title: n.name
            })
          }
          return new AMap.Marker()
        }, this.cinemas)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.map-view {
  position: relative;
  top: 94px;
  height: 200px;
  .map-container {
    height: 100%;
  }
}
.map-detail {
  z-index: 400;
  top: 44px;
  height: calc(~'100vh - 44px');
  .active-cinema {
    position: fixed;
    height: 49px;
    background: #ffff;
    width: 100%;
    bottom: 0;
    z-index: 401;
  }
}
</style>
